// extracted by mini-css-extract-plugin
module.exports = {"content":"cart-open-button-content_content__cuaIA","quantity":"cart-open-button-content_quantity__f8m_i","icon":"cart-open-button-content_icon__4wrYC"};